
import { Image } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { useSession } from "@/hooks/use-session";
import { SidebarSeparator } from "@/components/ui/sidebar";

interface SidebarHeaderProps {
  logoUrl: string | null;
  clientName: string | null;
}

export function SidebarHeader({ logoUrl, clientName }: SidebarHeaderProps) {
  const { session } = useSession();
  const userEmail = session?.user?.email;
  const userInitials = userEmail ? userEmail.charAt(0).toUpperCase() : 'U';

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.target as HTMLImageElement;
    target.src = "https://placehold.co/200x200?text=No+Logo";
  };

  return (
    <div className="space-y-4">
      {/* Logo Section */}
      <div className="px-4 py-4">
        {logoUrl ? (
          <img 
            src={logoUrl} 
            alt={clientName || 'School logo'} 
            className="w-32 h-auto mx-auto mb-2 object-contain"
            onError={handleImageError}
          />
        ) : (
          <div className="text-center">
            <Image className="w-32 h-32 mx-auto text-gray-400" />
          </div>
        )}
      </div>

      {/* User Info Section */}
      <div className="px-4 pb-4">
        <div className="flex items-center space-x-3">
          <Avatar>
            <AvatarFallback className="bg-primary text-primary-foreground">
              {userInitials}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col">
            <span className="text-sm font-medium">{clientName || 'User'}</span>
            <span className="text-xs text-gray-500">{userEmail}</span>
          </div>
        </div>
      </div>

      <SidebarSeparator />
    </div>
  );
}
